import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import { FaEnvelope, FaPhone, FaExternalLinkAlt } from 'react-icons/fa';

class ContactIcon extends Component {
  renderIcon = type => {
    if (type === 'link') return <FaExternalLinkAlt className="vertical-align-sub" />;
    if (type === 'phone') return <FaPhone className="vertical-align-sub" />;
    if (type === 'email') return <FaEnvelope className="vertical-align-sub" />;
    return '';
  };
  formatHref = (value, type) => {
    if (type === 'link') {
      if (value.indexOf('http://') === -1 && value.indexOf('https://') === -1) {
        value = `http://${value}`;
      }
      return value;
    }

    if (type === 'phone') return `tel:${value.replace(/[^0-9+]/g, '')}`;
    if (type === 'email') return `mailto:${value}`;
  };
  render() {
    const { type, value, onClick } = this.props;
    if (!value) return <span />;
    // override default href if an onclick was specified
    if (onClick) {
      return (
        <a onClick={onClick}>
          {this.renderIcon(type)} &nbsp; {value}
        </a>
      );
    }
    return (
      <a
        href={this.formatHref(value, type)}
        target={(type === 'link') === 2 ? '_blank' : ''}
        rel="noopener noreferrer"
      >
        {this.renderIcon(type)} &nbsp; {value}
      </a>
    );
  }
}
export default injectIntl(ContactIcon);
